import React, { useEffect, useRef } from "react";
import ChatMessage from "../chatMessage/ChatMessage";
import BackButton from "component/backButton/BackButton";
import AutoCompleteInput from "component/autoCompleteInput/AutoCompleteInput";
import MicrophoneButton from "../microphoneButton/MicrophoneButton";
import { Globalstate } from "context/context";
import assetsMaanager from "assets/assetsmanager/assestsmanager";
import { nanoid } from "nanoid";
import { createBotMessage, createUserMessage } from "utils/utils";
import useBingQna from "hooks/useBingQna";
import { condition } from "context/condition";
import { useWebSocket } from "context/WebSocketProvider";
import "./chatContainer.css";
import starIcon from "assets/photos/staricon.png"

const ChatContainer = ({
  handleSubmit,
  setIsFocused,
  inputRef,
  value,
  setValue,
  showCrossIcon,
  handlePause,
}) => {
  const { state, dispatch } = Globalstate();
  const { messages } = state;
  const containerRef = useRef();
  const { sendMessageBingSearch } = useWebSocket();
  const { mutateAsync: mutateAsyncBingQna } = useBingQna();

  const handleAvaamo = () => {
    let link = "abcd://adityabirlacapitaldigital.com/homePage/chatWithUsPage/";
    console.log(`SIMPLIFI:::${link}`);
  };

  const handleBingSearch = (responseId, query) => {
    const userKey = nanoid();
    const botKey = nanoid();
    const userMessage = createUserMessage(`${query}`, "", userKey);
    const botMessage = createBotMessage("", botKey, "", [], [], "");
    dispatch({ type: condition.SETMESSGES, payload: userMessage });
    dispatch({ type: condition.SETMESSGES, payload: botMessage });
    if (state.mode === "qna") {
      mutateAsyncBingQna({
        id: responseId,
        botKey: botKey,
        source: state.source,
        query: query
      });
    } else if (state.mode === "stream") {
      sendMessageBingSearch({
        id: responseId,
        botKey: botKey,
        source: state.source,
        query: query
      });
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleTranscriptionComplete = (result) => {
    console.log("Transcribed Text:", result.text);
    console.log("Detected Language:", result.language);
  };

  return (
    <div className="chat-container">
      {!state?.nudgeFlow && (
        <div className="backBtn back-btn">
          <BackButton />
        </div>
      )}
      <div className="chat-messages">
        <div
          className="abcd-cont"
          style={{ display: state.nudgeFlow && "none" }}
        >
          {state.source === "service" ? (
            <img src={assetsMaanager.serviceIcon} alt="" />
          ) : (
            <img src={assetsMaanager.abcdIcon} alt="" />
          )}
          <h4>SimpliFi, your AI-powered financial companion</h4>
          <p>
            SimpliFi aims to inform, not advise. For personalised financial
            advice, please consult a professional. <br /> Your ratings help us
            improve.
          </p>
        </div>
        {messages?.map((message, index) => {
          return (
            <ChatMessage
              key={message.key}
              userMessage={message.userMessage}
              index={index}
              messageSender={message.messageSender}
              messageKey={message.key}
              answer={message.answer}
              cta_results={message.cta_results}
              recommended_questions={message.recommended_questions}
              responseId={message.id}
              isBingResponse={message.isBingResponse}
              unavailability_flag={message.unavailability_flag}
              isLastMessage={index == messages.length - 1}
              isTranslatedResponse={message?.isTranslatedResponse || false}
              sourceCode={message?.source_code}
              question={message?.question}
              id={message?.id}
              nudgeFlag={message?.flag === "true" ? true : false}
              sources={message?.sources}
            />
          );
        })}
        {messages[messages?.length - 1]?.unavailability_flag && (
          <div ref={containerRef} className="bing-api-card">
            <img src={assetsMaanager.botImg} alt="" />
            <p>Didn't get what you were looking for?</p>
            <div className="buttons-group-dislike">
              {
                !state?.nudgeFlow ?
                  <button
                    onClick={() => {

                      handleBingSearch(
                        messages[messages?.length - 1]?.id,
                        // messages[messages?.length - 1]?.question
                        messages[messages?.length - 1]?.question ? messages[messages?.length - 1]?.question : messages[messages?.length - 2]?.answer

                      );
                    }}
                  >
                    <p>Explore Web Results</p>
                    <div className="prompts-card-button">
                      <img src={assetsMaanager.redArrowRight} alt="" />
                    </div>
                  </button> : ''
              }
              {/* <button onClick={handleAvaamo}>
                <p>Start a chat with our agent</p>
                <div className="prompts-card-button">
                  <img src={assetsMaanager.redArrowRight} alt="" />
                </div>
              </button> */}
              {/* <button onClick={handleAvaamo}>
                    <p>Connect over call</p>
                    <div className="prompts-card-button">
                      <img src={assetsMaanager.redArrowRight} alt="" />
                    </div>
                  </button> */}
            </div>
          </div>
        )}
      </div>
      <div>
        {
          state?.nudgeFlow ?
            <div
              className="ai-generated-section"
            >
              <img
                src={starIcon}
                alt="star"
              />
              AI-generated insights, not financial advice
            </div> : ''
        }
        <div className="input-field">
          <AutoCompleteInput
            setIsFocused={setIsFocused}
            handleSubmit={handleSubmit}
            inputRef={inputRef}
            value={value}
            setValue={setValue}
            showCrossIcon={showCrossIcon}
            handlePause={handlePause}
          />
          <MicrophoneButton
            handleSubmit={handleSubmit}
            handleTranscriptionComplete={handleTranscriptionComplete}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatContainer;
